import { useStrategies } from '@src/providers/StrategiesProvider';
import { EMPTY_OBJECT, IconName, type FilterableProperty, type StrategyScopeEnum } from '@talos/kyoko';
import { uniqBy } from 'lodash-es';
import { useMemo } from 'react';
/**
 * This hook creates the filter property definition for Strategies properties.
 *
 * @returns Filter Property definition to use for Strategies filters
 */

export function useStrategiesFilter(opts?: { strategyScope?: StrategyScopeEnum }) {
  const { strategiesByName, strategiesList } = useStrategies();
  const { strategyScope } = opts ?? EMPTY_OBJECT;

  return useMemo(() => {
    const filteredStrategies = strategyScope
      ? strategiesList?.filter(s => s.StrategyScope === strategyScope)
      : strategiesList;

    const getStrategyOptionDisplayName = (option: string) => {
      switch (option) {
        case '':
          return 'None';
        case 'RFQ':
          return 'RFQ';
        default:
          return strategiesByName?.get(option)?.DisplayName || '';
      }
    };

    return {
      ...({
        key: 'Strategies',
        label: 'Strategy',
        icon: IconName.DocumentText,
        // Include the option to lookup empty strategies and RFQ
        options: uniqBy(['', 'RFQ'].concat((filteredStrategies || []).map(s => s.Name)), getStrategyOptionDisplayName),
        getOptionLabel: getStrategyOptionDisplayName,
      } as const satisfies FilterableProperty),
    };
  }, [strategiesList, strategiesByName, strategyScope]);
}
